import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: "", password: "" });
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const res = await login(form.email, form.password);
        setSubmitting(false);
        if (res.ok) {
            toast.success("¡Bienvenido!");
            navigate(res.user.role === "admin" ? "/admin" : "/perfil");
        } else {
            toast.error(res.error);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="login-page">
            <div className="w-full max-w-md bg-white border border-border rounded-3xl shadow-xl p-8">
                <div className="text-center mb-6">
                    <div className="w-14 h-14 rounded-2xl bg-mexred text-cocoa flex items-center justify-center font-display font-bold text-2xl mx-auto mb-3">Dm</div>
                    <h1 className="font-display text-2xl font-semibold text-cocoa">Iniciar sesión</h1>
                    <p className="text-sm text-muted-foreground">Bienvenido de vuelta a la dulcería 🌶️</p>
                </div>
                <form onSubmit={onSubmit} className="space-y-4">
                    <div>
                        <label className="text-sm font-medium text-cocoa">Correo</label>
                        <input
                            data-testid="login-email"
                            type="email"
                            required
                            value={form.email}
                            onChange={(e) => setForm({ ...form, email: e.target.value })}
                            className="mt-1 w-full px-3 py-2.5 rounded-xl border border-border focus:border-mexred focus:ring-2 focus:ring-mexred/20 outline-none"
                        />
                    </div>
                    <div>
                        <label className="text-sm font-medium text-cocoa">Contraseña</label>
                        <input
                            data-testid="login-password"
                            type="password"
                            required
                            value={form.password}
                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                            className="mt-1 w-full px-3 py-2.5 rounded-xl border border-border focus:border-mexred focus:ring-2 focus:ring-mexred/20 outline-none"
                        />
                    </div>
                    <button
                        data-testid="login-submit-btn"
                        disabled={submitting}
                        className="w-full bg-mexred hover:bg-mexred_hover disabled:bg-muted text-cocoa rounded-full py-3 font-semibold transition-all shadow-md"
                    >
                        {submitting ? "Entrando..." : "Entrar"}
                    </button>
                </form>
                <p className="text-center text-sm text-muted-foreground mt-5">
                    ¿No tienes cuenta?{" "}
                    <Link to="/registro" className="text-cocoa font-semibold hover:underline">
                        Regístrate
                    </Link>
                </p>
                <div className="mt-6 pt-5 border-t border-border/60 text-center">
                    <Link
                        to="/"
                        data-testid="login-go-products"
                        className="inline-flex items-center gap-2 bg-marigold/20 hover:bg-marigold/40 text-cocoa font-semibold px-5 py-2.5 rounded-full transition-all"
                    >
                        🛍️ Ver productos
                    </Link>
                    <p className="text-xs text-muted-foreground mt-2">¿Solo quieres explorar? Vuelve a la tienda</p>
                </div>
            </div>
        </div>
    );
}
